import Swiper from "swiper/bundle";

const ReportsSlider = () => {
  const reportsSliders = [...document.querySelectorAll('.reports__slider')];
  const reportsNavLists = [...document.querySelectorAll('.reports__nav-list')];

  if (reportsSliders.length > 0 && reportsNavLists.length > 0) {
    const reportsNavList = new Swiper(".reports__nav-list", {
      lazy: true,
      slidesPerView: "auto",
      spaceBetween: 16,
      direction: "vertical",
      freeMode: true,
      loop: true,
      breakpoints: {
        1024: {
          spaceBetween: 20,
        },
      },
    });
  
    const reportsSlider = new Swiper(".reports__slider", {
      slidesPerView: "auto",
      spaceBetween: 16,
      direction: "horizontal",
      loop: true,
      thumbs: {
        swiper: reportsNavList,
      },
      pagination: {
        el: ".reports__slider-pagination",
        clickable: true,
      },
      breakpoints: {
        768: {
          direction: "vertical",
          slidesPerView: 1,
        },
      },
    });
  }
}

export default ReportsSlider;


